import handleNestedId from '../lib/handleNestedId.ts';
import InputLabel from '../partials/InputLabel/index.tsx';
import TextInputBase from '../partials/TextInputBase/index.tsx';
import InputError from '../partials/InputError/index.tsx';

export interface TextInputProps {
  className?: string;
  variant?: string;
  type?: 'text' | 'email' | 'number' | 'password' | 'tel';
  id: string;
  label: string;
  description?: string;
  placeholder?: string;
  value?: string;
  onChange?: () => void;
  onBlur?: () => void;
  disabled?: boolean;
  errors?: { [key: string]: { type: string; message: string } };
}

const TextInput = ({
  className,
  variant,
  type = 'text',
  id,
  label,
  description,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled,
  errors,
}: TextInputProps) => {
  const fieldId = handleNestedId(id);
  const hasErrors = !!errors && !!Object.keys(errors).length;

  return (
    <div
      data-testid="text-input"
      className={`cef-ui-text-input${
        variant ? ` cef-ui-text-input--${variant}` : ''
      }${className ? ` ${className}` : ''}`}>
      <InputLabel id={id} label={label} description={description} />

      <TextInputBase
        type={type}
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        hasErrors={hasErrors}
      />

      {hasErrors && fieldId && errors[fieldId] && (
        <InputError errorMessage={errors[fieldId].message} />
      )}
    </div>
  );
};

export default TextInput;
